import React from 'react';
import { HashRouter, Routes, Route } from 'react-router-dom';
import MainLayout from './layouts/MainLayout';
import Overview from './pages/Overview';
import BottleneckRadar from './pages/BottleneckRadar';
import Playbooks from './pages/Playbooks';
import Settings from './pages/Settings';
import DemoPage from './pages/DemoPage';
import PlaceholderPage from './pages/PlaceholderPage';

function App() {
  return (
    <HashRouter>
      <Routes>
        <Route path="/" element={<MainLayout />}>
          <Route index element={<Overview />} />
          <Route path="demo" element={<DemoPage />} />
          <Route path="radar" element={<BottleneckRadar />} />
          <Route path="queues" element={<PlaceholderPage title="Task Queues" description="Real-time ingestion and processing queues for operational tasks." />} />
          <Route path="workload" element={<PlaceholderPage title="Team Workload" description="Resource allocation and capacity planning matrix." />} />
          <Route path="playbooks" element={<Playbooks />} />
          <Route path="settings" element={<Settings />} />
        </Route>
      </Routes>
    </HashRouter>
  );
}

export default App;